var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { Component } from 'react';
import { connect } from 'mini-store';
import TableRow from './TableRow';
var ExpandableTable = /** @class */ (function (_super) {
    __extends(ExpandableTable, _super);
    function ExpandableTable(props) {
        var _this = _super.call(this, props) || this;
        // 在表头的最前面插入一个空的单元格
        _this.renderExpandIndentCell = function (rows) {
            var expandIconAsCell = _this.props.expandIconAsCell;
            if (!expandIconAsCell) {
                return;
            }
            var iconColumn = {
                key: 'table-expand-icon-cell',
                title: '',
                rowSpan: rows.length,
            };
            rows[0].unshift(__assign(__assign({}, iconColumn), { column: iconColumn }));
        };
        // 渲染展开行
        _this.renderExpandedRow = function (record, index, render, ancestorKeys, indent, fixed) {
            var expandIconAsCell = _this.props.expandIconAsCell;
            var parentKey = ancestorKeys[ancestorKeys.length - 1];
            var rowKey = parentKey + "-extra-row";
            var components = {
                body: {
                    row: 'tr',
                    cell: 'td',
                },
            };
            var colCount;
            colCount = _this.columnManager.leafColumns().length;
            var columns = [
                {
                    key: 'extra-row',
                    render: function () {
                        var _a = _this.store.getState().expandedRowKeys, expandedRowKeys = _a === void 0 ? [] : _a;
                        var expanded = expandedRowKeys.includes(parentKey);
                        return {
                            props: {
                                colSpan: expandIconAsCell ? colCount + 1 : colCount,
                            },
                            children: fixed !== 'right' ? render(record, index, indent, expanded) : '&nbsp;',
                        };
                    },
                },
            ];
            return (React.createElement(TableRow, { key: rowKey, columns: columns, rowKey: rowKey, ancestorKeys: ancestorKeys, indent: indent, fixed: fixed, components: components, expandedRow: true }));
        };
        // 渲染所有行
        _this.renderRows = function (renderRows, rows, record, index, indent, fixed, parentKey, ancestorKeys) {
            var expandedRowRender = _this.props.expandedRowRender;
            var nextAncestorKeys = __spread(ancestorKeys, [parentKey]);
            var nextIndent = indent + 1;
            if (expandedRowRender) {
                rows.push(_this.renderExpandedRow(record, index, expandedRowRender, nextAncestorKeys, nextIndent, fixed));
            }
        };
        // 点击展开折叠
        _this.handleExpandChange = function (expanded, record, event, rowKey, destroy) {
            if (destroy === void 0) { destroy = false; }
            var expandedRowKeys = _this.store.getState().expandedRowKeys;
            if (event) {
                event.stopPropagation();
            }
            if (expanded) {
                expandedRowKeys = __spread(expandedRowKeys, [rowKey]);
            }
            else {
                var expandedRowIndex = expandedRowKeys.indexOf(rowKey);
                if (expandedRowIndex !== -1) {
                    expandedRowKeys = expandedRowKeys.filter(function (item) { return item !== rowKey; });
                }
            }
            if (!_this.props.expandedRowKeys) {
                _this.store.setState({ expandedRowKeys: expandedRowKeys });
            }
        };
        var expandedRowKeys = props.expandedRowKeys, defaultExpandedRowKeys = props.defaultExpandedRowKeys;
        _this.columnManager = props.columnManager;
        var finalExpandedRowKeys = [];
        finalExpandedRowKeys = expandedRowKeys || defaultExpandedRowKeys;
        _this.store = props.store;
        _this.store.setState({
            expandedRowsHeight: {},
            expandedRowKeys: finalExpandedRowKeys,
        });
        return _this;
    }
    ExpandableTable.prototype.render = function () {
        var children = this.props.children;
        return children({
            props: this.props,
            renderExpandIndentCell: this.renderExpandIndentCell,
            renderRows: this.renderRows,
            handleExpandChange: this.handleExpandChange,
        });
    };
    ExpandableTable.defaultProps = {
        expandIconAsCell: false,
        expandIconColumnIndex: 0,
        defaultExpandedRowKeys: [],
    };
    return ExpandableTable;
}(Component));
export default connect()(ExpandableTable);
